module.exports = __webpack_public_path__ + "img/bookmark.df258d8e.svg";